import { useTranslation } from "react-i18next";
import { PaginatedData } from "../../../hooks/PaginationHooks";
import { TableHeaderWrapper } from "../../../components/common/Common.styles";
import ServerSideTableColumnHeader from "../../../components/common/table/ServerSideTableColumnHeader";
import BorderRow from "../../../components/common/table/BorderRow";
import { CompanyInvoiceFile } from "../../../types/invoiceTypes";

interface Props {
    paginatedData: PaginatedData<CompanyInvoiceFile>;
    showCompanyName: boolean;
}

export default function InvoicesTableHeader(props: Props) {
    const { t } = useTranslation();

    return (
        <TableHeaderWrapper>
            <ServerSideTableColumnHeader
                fieldName="invoiceNumber"
                firstCol
                isSorted
                label={t("tableColumnHeaders.invoiceNumber")}
                paginatedData={props.paginatedData}
            />
            <ServerSideTableColumnHeader
                fieldName="invoiceDate"
                isSorted
                label={t("tableColumnHeaders.invoiceDate")}
                paginatedData={props.paginatedData}
            />
            {
                props.showCompanyName &&
                <ServerSideTableColumnHeader
                    fieldName="companyName"
                    isSorted
                    label={t("tableColumnHeaders.companyName")}
                    paginatedData={props.paginatedData}
                />
            }
            <ServerSideTableColumnHeader
                fieldName="downloadUrl"
                isSorted={false}
                label={t("tableColumnHeaders.download")}
                paginatedData={props.paginatedData}
            />
            <BorderRow />
        </TableHeaderWrapper>
    );
};
